import Joi from 'joi';

export const brandingTypeFormSchema = Joi.object({
  name: Joi.string().required().messages({
    'string.empty': 'Name should not be empty',
  }),
});
